import { useState, useEffect } from 'react';
import { Marker } from '@vis.gl/react-google-maps';
import { getBreakpoint } from '../utils/breakpoints'

const myStoreDataInitial = JSON.parse(localStorage.getItem('bentley_my_store')); // The users selected store

export const StoreLocatorMarker = ({ store, setInfoWindowOpen, setInfoWindowStore }) => {
  const [myStoreData, setMyStoreData] = useState(myStoreDataInitial);
  const [isHovered, setIsHovered] = useState(false);

  useEffect(() => {
    document.addEventListener('myStoreUpdated', () => {
      const newStoreData = JSON.parse(localStorage.getItem('bentley_my_store'));

      setMyStoreData(newStoreData);
    });

    return () => {
      document.removeEventListener('myStoreUpdated', () => {});
    };
  }, []);

  const isMyStore = myStoreData && myStoreData.id === store.id;

  return (
    <>
      <Marker
        onClick={() => {
          setInfoWindowOpen(true);
          setInfoWindowStore(store);

          const storeLocationElement = document.querySelector(`#store-${store.handle}`)?.closest('.store-location');

          if (storeLocationElement && getBreakpoint() != 'mobile' && getBreakpoint() != 'tablet') {
            const storeLocationElementTop = storeLocationElement.getBoundingClientRect().top + window.scrollY;

            // Need to check if we are scrolling down or up to determine the scroll position (due to header size change)
            if (window.scrollY > storeLocationElementTop) {
              window.scrollTo({
                top: storeLocationElementTop - 156,
                behavior: 'smooth'
              });
            } else {
              window.scrollTo({
                top: storeLocationElementTop - 100,
                behavior: 'smooth'
              });
            }
          }
        }}
        position={{lat: parseFloat(store.latitude), lng: parseFloat(store.longitude)}}
        icon={{
          url: isMyStore ? 'https://cdn.shopify.com/s/files/1/0691/4542/8221/files/Bentley-marker-pin3.svg?v=1712774243' : 'https://cdn.shopify.com/s/files/1/0691/4542/8221/files/Bentley-marker-pin2.svg?v=1712774110',
          scaledSize: isHovered ? {width: 80, height: 80} : {width: 70, height: 70}
        }}
        zIndex={isMyStore ? 99999 : null}
        onMouseOver={() => setIsHovered(true)}
        onMouseOut={() => setIsHovered(false)}
      />
    </>
  )
}
